import store from "../../store";

export enum SOCKET_ACTIONS {
  START_SESSION= "START_SESSION",
  NEXT_CLIENT = "NEXT_CLIENT",
  CLOSE_GATE = "CLOSE_GATE",
  CLIENT_EXIT = "CLIENT_EXIT",
  CLIENT_ENTER = "CLIENT_ENTER",
  STOP_SESSION = "STOP_SESSION",
  UPDATE_QUEUE = "UPDATE_QUEUE",
  SESSION_STARTED = "SESSION_STARTED",
  DOORS_OPEN = "DOORS_OPEN",
  DOORS_CLOSED = "DOORS_CLOSED",
  RESET_SESSION = "RESET_SESSION",
  ENTER_TIMEOUT = "ENTER_TIMEOUT",
  EXIT_TIMEOUT = "EXIT_TIMEOUT",
  MAX_REACHED = "MAX_REACHED",
}

export enum DEVICE_ACTIONS {
  CREATE_SOCKET = "SOCKET_CREATE_SOCKET",
  CLOSE_CONNECTION = "SOCKET_CLOSE_CONNECTION",
  SESSION_STARTED = "SOCKET_SESSION_STARTED",
  SET_DOOR_STAGE = "SOCKET_SET_DOOR_STAGE",
  SET_TIMER_DATA = "SOCKET_SET_TIMER_DATA",
  UPDATE_QUEUE = "SOCKET_UPDATE_QUEUE",
  SET_IN_TIMEOUT = "SET_IN_TIMEOUT",
  SET_MAX_REACHED = "SET_MAX_REACHED",
}

export const createConnection = () => store.dispatch({ type: DEVICE_ACTIONS.CREATE_SOCKET });
export const closeConnection = () => store.dispatch({ type: DEVICE_ACTIONS.CLOSE_CONNECTION });
export const sessionStarted = (payload) => store.dispatch({ type: DEVICE_ACTIONS.SESSION_STARTED, payload });
export const setStageDoors = (stage) => store.dispatch({ type: DEVICE_ACTIONS.SET_DOOR_STAGE, payload: stage });
export const setTimeData = (time) => store.dispatch({ type: DEVICE_ACTIONS.SET_TIMER_DATA,  payload: time });
export const updateQueue = (payload) => store.dispatch({ type: DEVICE_ACTIONS.UPDATE_QUEUE,  payload });
export const setInTimeout = (payload: boolean) => store.dispatch({ type: DEVICE_ACTIONS.SET_IN_TIMEOUT,  payload });
export const setMaxReachedModal = (payload: boolean) => store.dispatch({ type: DEVICE_ACTIONS.SET_MAX_REACHED, payload });

export const handleMessage = (message) => {
  switch (message.type) {
    case SOCKET_ACTIONS.SESSION_STARTED: {
      sessionStarted(message.payload);
      break;
    }
    case SOCKET_ACTIONS.DOORS_OPEN: {
      setStageDoors(1);
      // setTimeData(message.payload);
      break;
    }
    case SOCKET_ACTIONS.DOORS_CLOSED: {
      setStageDoors(0);
      // setMaxReachedModal(false);
     // setTimeData(message.payload.waitTime);
      break;
    }
    case SOCKET_ACTIONS.UPDATE_QUEUE: {
      updateQueue(message.payload);
      break;
    }
    case SOCKET_ACTIONS.ENTER_TIMEOUT: {
      setInTimeout(true);
      break;
    }
    case SOCKET_ACTIONS.EXIT_TIMEOUT: {
      setInTimeout(false);
      break;
    }
    case SOCKET_ACTIONS.MAX_REACHED: {
      setMaxReachedModal(true);
      break;
    }
    default:
      break;
  }
};
